import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReportPage from "./ReportPage";
import { show_proper_words } from "../../utils/Constant";

export default function ReportPostJobModal({
  open,
  onClose,
  reportTo = "Post",
  targetId = "",
  callBackFunction = () => { },
  width = "850px",
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="paper"
      className="custom-model-wrapper"
      PaperProps={{
        className: "custom-model-paper",
        style: {
          width: width,
          maxWidth: "90%",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #e0e0e0",
          pb: 1,
        }}
        className="text-capitalize"
      >
        Report {show_proper_words(reportTo)}
        <div onClick={onClose} className="model-red-cross">
          <CloseIcon />
        </div>
      </DialogTitle>

      <DialogContent className="p-4 card-1 custom-modal-content">
        <ReportPage
          closeModal={onClose}
          report_to={reportTo}
          callBackFunction={callBackFunction}
          targetId={targetId}
        />
      </DialogContent>
    </Dialog>
  );
}
